import { render, staticRenderFns } from "./MenuSuperior.vue?vue&type=template&id=4669549b"
import script from "./MenuSuperior.vue?vue&type=script&lang=js"
export * from "./MenuSuperior.vue?vue&type=script&lang=js"
import style0 from "./MenuSuperior.vue?vue&type=style&index=0&id=4669549b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports